// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2wsLc","rootCenter":"LoadMoreObserver_rootCenter__3i3xw","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2HHr6"};